"use client";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  color?: string;
  showText?: boolean;
  customText?: string;
  className?: string;
  fullScreen?: boolean;
}

export function LoadingSpinner({
  size = "md",
  color = "#EE7B11",
  showText = true,
  customText = "Carregando...",
  className = "",
  fullScreen = true,
}: LoadingSpinnerProps) {
  const sizeMap = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  const textSizeMap = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base",
  };

  return (
    <div
      className={`flex items-center justify-center ${
        fullScreen ? "fixed inset-0 bg-white/80 z-50" : "h-full"
      } ${className}`}
    >
      <div className="flex flex-col items-center">
        <div className="relative" role="status" aria-label="Carregando">
          <div
            className={`rounded-full border-2 border-t-transparent animate-spin ${sizeMap[size]}`}
            style={{
              borderColor: `${color} transparent transparent transparent`,
            }}
          />
          <div
            className="absolute inset-0 rounded-full border-2 opacity-20"
            style={{ borderColor: color }}
          />
        </div>
        {showText && (
          <p
            className={`mt-2 font-medium ${textSizeMap[size]}`}
            style={{ color }}
            aria-live="polite"
          >
            {customText}
          </p>
        )}
      </div>
    </div>
  );
}
